import * as React from "react";

import { IEventViewProps } from "../EventView";

import { IDayCell_MonthMobile, IDayCellSlot_MonthMobile } from "../../../classes/dayCell_MonthMobile";
import { IText } from "../../../classes/Text";

import { MonthListDay } from "./MonthListDay";

import * as dates from "../../../reducers/changeTimePeriod";

import * as utils from "../Common/ListViewUtils";

const getDayListItemsForMonth = (theDayCells: IDayCell_MonthMobile[], props: IEventViewProps) => {
    const dayListItems: JSX.Element[] = [];

    for (const dayCell of theDayCells) {
        if (dates.getMonthNumber(props.currentDate) === dates.getMonthNumber(dayCell.date)) {
            dayListItems.push(
                <MonthListDay
                    key={dayCell.cellNumber}
                    dayCell={dayCell}
                    currentDate={props.currentDate}
                    selectedDate={props.selectedDate}
                    todaysDate={props.todaysDate}
                    text={props.text}
                    contextId={props.contextId}
                    pageId={props.pageId}
                    parentId={props.parentId}
                    portalId={props.portalId}
                    portletInstanceId={props.portletInstanceId}
                    userDateFormat={props.userDateFormat}
                    viewMode={props.viewMode}
                    onStartAjaxCall={props.onStartAjaxCall}
                    onSetEventId={props.onSetEventId}
                    onSetEventScreenMode={props.onSetEventScreenMode}
                    onSetiCalStartDate={props.onSetiCalStartDate}
                    onSetDisplayedEventLocalStartDate={props.onSetDisplayedEventLocalStartDate}
                    onSetDisplayedEventLocalEndDate={props.onSetDisplayedEventLocalEndDate}
                    onSetCurrentDate={props.onSetCurrentDate}
                    onSetSelectedDate={props.onSetSelectedDate}
                    onSetViewMode={props.onSetViewMode}
                />);
        }
    }

    return dayListItems;
};

const createFakeEventWithNewSelectedDate = (selectedDate: Date): any => {
    // Create fake event, and pass corrected selectedDate into it. This feels a bit cludgy.
    const e: any = {};
    e.currentTarget = {};
    e.currentTarget.attributes = {};
    e.currentTarget.attributes["data-date"] = {};
    e.currentTarget.attributes["data-date"].value = selectedDate.toString();
    e.preventDefault = () => { const x = 1; }; // Dummy do-nothing event.
    return e;
};

const handleIfSelectedDateIsNotInMonth = (props: IEventViewProps) => {
    // In standard month view, can set selected date to last days of previous month or first days of next month. Those extra days are not displayed in the mobile view,
    // so if the selected date is outside the displayed month, need to move the selected date to the start/end of the displayed month.
    // Example: Go to August 2017 in Standard Monthly View. Set the selected date to 31st September. Narrow screen to switch to mobile view. 31st September is no longer
    // displayed. Without this fix, when you clicked Add Event, the event would be added to 31st September, even though you are looking at August.

    const firstDayOfCurrentMonth = dates.getFirstDateInCurrentMonth_Mobile(props.currentDate);
    if (dates.isBefore(props.selectedDate, firstDayOfCurrentMonth)) {
        const e: any = createFakeEventWithNewSelectedDate(firstDayOfCurrentMonth);
        props.onSetSelectedDate(e);
    }

    const lastDayOfCurrentMonth = dates.getLastDateInCurrentMonth_Mobile(props.currentDate);
    if (dates.isAfter(props.selectedDate, lastDayOfCurrentMonth)) {
        const e: any = createFakeEventWithNewSelectedDate(lastDayOfCurrentMonth);
        props.onSetSelectedDate(e);
    }
};

export const MonthListDays = (props: IEventViewProps) => {

    handleIfSelectedDateIsNotInMonth(props);

    // Convert list of events into array of day cells for days of the month, each with event slots.
    const dayCells: IDayCell_MonthMobile[] = utils.transformListOfEventsIntoArrayOfDayCellsForMonth_Mobile(props);

    // Generate JSX list items for the days of the month.
    const days = getDayListItemsForMonth(dayCells, props);

    return (
        <div className="CAL-scroll-wrapper">
            <ul className="CAL-V-MV-list">
                {days}
            </ul>
        </div>
    );
};
